// extracted by mini-css-extract-plugin
export default {"inputComponent":"_13cPZGKZlCiMe9e0DxAYXW","label":"w46xwgj2Fq8i4tSiBsDm0","alternativeLabel":"_38dlOwk-sUI8Ugy2suGDIJ"};